import { render } from "./NImageViewerBboxLayer.vue?vue&type=template&id=3bb0e2ec&ts=true"
import script from "./NImageViewerBboxLayer.vue?vue&type=script&lang=ts"
export * from "./NImageViewerBboxLayer.vue?vue&type=script&lang=ts"

import "./NImageViewerBboxLayer.vue?vue&type=style&index=0&id=3bb0e2ec&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__